import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { ProductService } from 'src/app/shared/services/product.service';
import { ToastService } from 'src/app/shared/services/toastr.service';

@Component({
  selector: 'app-cancel-order-confirmation-dialog',
  templateUrl: './cancel-order-confirmation-dialog.component.html',
  styleUrls: ['./cancel-order-confirmation-dialog.component.scss']
})
export class CancelOrderConfirmationDialogComponent implements OnInit {


  totalAmount = 0;
  deductionAmount = 0;
  refundAmount = 0;

  constructor(
    private cartService: ProductService,
    private apiFactory: APIFactoryEndPoints,
    private toastService: ToastService,
    private dialogRef: MatDialogRef<CancelOrderConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {

  }

  ngOnInit() {

    this.totalAmount =
      Number(this.dialogData.order.totalAmount || 0) +
      Number(this.dialogData.order.shippingDetails?.totalAmount || 0);

    if (this.dialogData.refundSetup.refundApplicable) {

      this.deductionAmount =
        this.totalAmount *
        this.dialogData.refundSetup.deductionPercentage / 100;

    }

    this.refundAmount =
      this.totalAmount - this.deductionAmount;

  }

  onBack() {

    this.dialogRef.close();

  }

  onProceed() {
    this.cartService.cancelOrder(this.apiFactory.cancelOrder, this.dialogData.order.orderNo, 'WEBORDER', this.refundAmount).subscribe((response: any) => {
      if (response.data) {
        this.toastService.showSuccessToast('Order cancelled successfully.');
        this.dialogRef.close('PROCEED');
      }
    });
  }

}
